import { VMType } from "@orb-labs/types";
export class EVM {
    static getDerivationPath(accountIdx) {
        return `m/44'/60'/0'/0/${accountIdx ?? 0}`;
    }
    static getWalletAccountConfig(accountIdx) {
        return {
            curve: "CURVE_SECP256K1",
            addressFormat: "ADDRESS_FORMAT_ETHEREUM",
            pathFormat: "PATH_FORMAT_BIP32",
            path: this.getDerivationPath(accountIdx),
        };
    }
    /**
     * Parse an EIP-681 Ethereum URI.
     *
     * @see https://eips.ethereum.org/EIPS/eip-681
     */
    static parseUri(uri) {
        const withoutScheme = uri.replace(/^ethereum:/i, "");
        const [pathPart, queryString] = withoutScheme.split("?");
        const pathSegments = pathPart.split("/");
        const addressAndChain = pathSegments[0];
        let address;
        let chainId;
        if (addressAndChain.includes("@")) {
            const [addr, chainStr] = addressAndChain.split("@");
            address = addr;
            chainId = parseInt(chainStr, 10);
            if (isNaN(chainId))
                chainId = undefined;
        }
        else {
            address = addressAndChain;
        }
        const params = new URLSearchParams(queryString || "");
        const value = params.get("value") ?? undefined;
        const functionName = pathSegments[1];
        let tokenAddress;
        let amount = value;
        if (functionName === "transfer") {
            tokenAddress = address;
            const recipientAddress = params.get("address");
            if (recipientAddress) {
                address = recipientAddress;
            }
            amount = params.get("uint256") ?? undefined;
        }
        return {
            vmType: VMType.EVM,
            address,
            chainId,
            amount,
            tokenAddress,
        };
    }
}
